<template>
  <div class="index">
    <div style="line-height:0">
      <img
        class="index-title"
        src="https://cbgccdn.thecover.cn/@/images/20211129/1638170328811032045.png"
        alt=""
      />
      <img
        class="index-title"
        src="https://cbgccdn.thecover.cn/@/images/20211129/1638170324020019925.png"
        alt=""
      />
    </div>

    <div class="main-ctrls">
      <button class="btn" @click="onBtnClick">{{ userStatus.tip }}</button>
      <button class="btn" @click="$router.push('/rank')">排行榜</button>
      <button
        class="btn"
        @click="showRecords = true"
        v-if="userStatus.status > 1 && userStatus.status < 4"
      >
        打卡查询
      </button>
      <button class="btn" @click="showRules = true">活动规则</button>
    </div>
    <!-- 
    <div class="organizitions">
      主办单位：四川省机关事务管理局<br />
      技术支持：川观新闻
    </div> -->
    <transition name="modal">
      <page v-if="showRecords" :isModal="true" v-on:back="showRecords = false">
        <records
          :records="clockinList"
          :max_recent_cont="max_recent_cont"
          :max_cont="max_cont"
        ></records>
      </page>
    </transition>

    <transition name="modal">
      <page v-if="showRules" :isModal="true" v-on:back="showRules = false">
        <div class="rule-wrap">
          <p class="rule-title">活动规则</p>
          <p>
            参与者用手机下载“川观新闻”APP，完成注册后进入活动页面，依次填写所在地等信息，注册成功后参与网络竞答；答题得分由系统自动记录，线上活动结束前可每日连续参与并累计积分。
          </p>
          <p>
            此次网络知识竞答分市（州）、县（市、区）、个人三个组别，
            集体等级奖、优胜奖获得者颁发荣誉证书；个人等级奖获得者颁
            发荣誉证书，个人等级奖、幸运奖获得者同时获得“川观新闻” App
            提供的相关奖励。
          </p>
          <p>
            市（州）组别：总分位列前 10
            位的获得市（州）组等级奖，其余市（州）为优胜奖；
          </p>

          <p>
            县（市、区）组别：总分位列县（市、区）类别前10位的
            分获等级奖，总分位列县（市、区）类别 11 至 20 名的获得优胜奖；
          </p>
          <p>
            个人组别：个人前3名分获等级奖，前 4 至 10
            名获得优胜奖，参与答题者均可参与抽取幸运奖（100 名）。
          </p>
        </div>
      </page>
    </transition>
  </div>
</template>

<script>
import page from "../../components/page";
import records from "./records";
import { Button, Cascader, Field, Popup, Toast } from "vant";
import {
  USER_STATUS,
  DAY_IN_SECONED,
  DURATION,
  START_DATE,
  POSTERS,
} from "./config";
import { login, getClockinList } from "../../apis/index";
import { cbgcAnalyze,recordRecent } from "../../utils/index";
import VConsole from "vconsole";
export default {
  components: { page, Button, Field, Cascader, Popup, records },
  data() {
    return {
      showRecords: false,
      showRules: false,
      userStatus: USER_STATUS[0],
      startDate: START_DATE,
      isClockined: false,
      clockinList: [],
      max_cont: 0,
      max_recent_cont: 0,
      showPoster: false,
      posterUrl: POSTERS[0],
    };
  },
  created() {
    if (this.$route.query.debug) {
      new VConsole();
    }
    // this.getRecords();
    if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
      var an_timer = setInterval(() => {
        if (window.AndroidBridging) {
          clearInterval(an_timer);
          this.preCheck();
        }
      }, 50);
    } else {
      this.preCheck();
    }
    cbgcAnalyze({
      activeId: "GGWHFUQA",
      activeName: "公共文化服务答题",
    });
    recordRecent('GGWHFUQA')
  },
  methods: {
    getRecords() {
      let toast = Toast({
        type: "loading",
        duration: 0,
      });
      getClockinList().then((resp) => {
        toast.clear();
        this.isClockined = [].concat(resp.data.list);
        this.clockinList = resp.data.list;
        this.max_cont = resp.data.max_cont;
        this.max_recent_cont = resp.data.max_recent_cont;
        if (resp.data.clock_in) {
          if (this.userStatus.status !== 6 && this.userStatus.status !== 5) {
            this.userStatus = USER_STATUS[3];
          }
        }
      });
    },
    onBridgeSuccess(resp, isBind) {
      let _this = this;
      let info = typeof resp === "string" ? JSON.parse(resp) : resp;
      if (info && info.user_id) {
        // 有user_ID 已登录
        console.log("already login");
        console.log(info);
        if (info.mobile) {
          console.log("有手机号");
          _this.userInfo = info;
          login(info).then(() => {
            if (
              _this.userStatus.status !== 6 &&
              _this.userStatus.status !== 5
            ) {
              _this.userStatus = USER_STATUS[2];
            }
            _this.getRecords();
          });
        } else {
          console.log("无手机号");
          // 无手机号 设置为绑定手机
          _this.userStatus = USER_STATUS[1];
        }
      } else {
        if (!isBind) {
          _this.userStatus = USER_STATUS[0];
        }
      }
    },
    onBtnClick() {
      let _this = this;
      if (this.userStatus.status === 0) {
        COVERAPP.Method.OpenLogin({
          callback: function (resp) {
            _this.onBridgeSuccess(resp);
          },
        });
      } else if (this.userStatus.status === 1) {
        COVERAPP.Method.bindMobile({
          callback: function (resp) {
            _this.onBridgeSuccess(resp, true);
          },
        });
      } else if (this.userStatus.status === 2) {
        this.$router.push("/qa");
      } else if (this.userStatus.status === 4) {
        goAppLink("https://cbgc.scol.com.cn/news/2530512");
        // https://cbgc.scol.com.cn/news/1427519
      }
    },
    preCheck() {
      if (COVERAPP.Attribute.isApp()) {
        let now = new Date();
        let _this = this;
        if (now < this.startDate.getTime()) {
          this.userStatus = USER_STATUS[5];
        } else if (now > this.startDate.getTime() + DURATION * DAY_IN_SECONED) {
          this.userStatus = USER_STATUS[6];
        }
        COVERAPP.Method.GetUser({
          callback: function (resp) {
            _this.onBridgeSuccess(resp);
          },
        });
      } else {
        this.userStatus = USER_STATUS[4];
        location.replace("https://cbgc.scol.com.cn/news/2530512");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.poster-bg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 60%;
    border-radius: 5px;
    margin-bottom: 5px;
  }

  div {
    color: rgb(184, 182, 182);
    margin-bottom: 10px;
    font-size: 10px;
  }

  button {
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #fff;
    //   background-color: #1e7a87;
    background-color: #ebd275;
    background-image: url("https://cbgccdn.thecover.cn/@/images/20210528/1622187450857017362.png");
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center center;
    box-shadow: 0 2px 1px 1px #9c8943;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.organizitions {
  // margin-top: 50px;
  color: #fff;
  font-size: 12px;
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
}
.index {
  width: 100%;
  height: 100%;
  background-image: url("https://cbgccdn.thecover.cn/@/images/20211129/1638170306141077956.jpg");
  background-size: 100% 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 7vw;
  .index-title {
    width: 100%;
  }
}
.main-ctrls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  .btn {
    flex: 0 0 auto;
    margin-bottom: 20px;
  }
}

.rule-wrap {
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 5px 5px 0px 0px rgba(255, 255, 255, 0.7);
  border: 2px solid #111;
  padding: 15px;
  text-align: left;
  .rule-title {
    text-align: center;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 2px 2px 2px #ffd30b;
  }
  p {
    margin: 0;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
  }
}
</style>